import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  CircularProgress,
} from '@mui/material'
import { DeleteOutline, WarningAmber, HelpOutline } from '@mui/icons-material'

interface ConfirmDialogProps {
  open: boolean
  title: string
  message: string
  confirmLabel?: string
  confirmColor?: 'error' | 'warning' | 'primary'
  onConfirm: () => void
  onClose: () => void
  loading?: boolean
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  confirmColor = 'error',
  onConfirm,
  onClose,
  loading,
}: ConfirmDialogProps) {
  const Icon = confirmColor === 'error' ? DeleteOutline : confirmColor === 'warning' ? WarningAmber : HelpOutline
  const tone = confirmColor === 'error'
    ? { color: '#D9363E', background: '#FFF1F2' }
    : confirmColor === 'warning'
      ? { color: '#C96D08', background: '#FFF7E6' }
      : { color: '#168FCA', background: '#EAF7FD' }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <Box sx={{ width: 40, height: 40, borderRadius: 2.5, display: 'grid', placeItems: 'center', ...tone }}>
          <Icon fontSize="small" />
        </Box>
        {title}
      </DialogTitle>
      <DialogContent sx={{ pl: { sm: 9.5 }, pb: 2 }}>
        <DialogContentText sx={{ color: 'text.secondary', lineHeight: 1.6 }}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 0.75 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          onClick={onConfirm}
          disabled={loading}
          autoFocus
        >
          {loading && <CircularProgress size={15} color="inherit" sx={{ mr: 1 }} />}
          {loading ? 'Working…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
